import { render, staticRenderFns } from "./docSave.vue?vue&type=template&id=65ba8c19&scoped=true"
import script from "./docSave.vue?vue&type=script&lang=js"
export * from "./docSave.vue?vue&type=script&lang=js"
import style0 from "./docSave.vue?vue&type=style&index=0&id=65ba8c19&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ba8c19",
  null
  
)

export default component.exports